
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import coverNoteService from '@/apps/shared/services/coverNote-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        components: {
            XBreadcrumb,
            WhatsApp
        },
        data() {
            return {
                modulesPlan: [],
                premioMensual: null,
                coberturas: [],
                Plandata: [],
                selectedPlan: null,
                finallyCalculationResult: [],
                plans: null,
                col: 2,
                plansLength: null,
                notCover: null,
                descriptionPlanNote: null,
                decimalPremioMensual: null,
                tabOneWelcome: null,
                dataGood: null,
                rangeSelected: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Cotizador de Equipo Electrónico', path: '/tecnologia/cotizarEquipoElectronico' },
                    { text: 'Valor de tu dispositivo', path: '/tecnologia/valorEquipoElectronico' },
                    { text: 'Elegi un Plan', path: '/tecnologia/elegiPlan' },
                ],
                leadId: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                const actualStep = 'quoted';

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = this.tabOneWelcome.lastName;
                request.firstName = this.tabOneWelcome.firstName;
                request.phone = this.tabOneWelcome.areaCode + this.tabOneWelcome.telephone;
                request.mail = this.tabOneWelcome.email;
                request.quotePlan = this.plans.map(plan => plan.planDescription).join(' - ');
                request.quotationDetail = "Producto: " + defaultTitle
                                + " - Equipo: " + this.dataGood.productDescription
                                + " - Valor: " + this.rangeSelected.productDescription;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'electronic-equipment-range-view',
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            selectedPlans: function (quotationData) {
                // se le envia el pricingId del plan que se haya elegido
                var pricingId = parseInt(quotationData.pricingId[0])
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        this.$router.push({
                            name: 'ElectronicDeviceClientData'
                        });
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                            'product': 'tecnologia',
                            'event': 'errorServidor',
                            'paso': 'cotizador-tecnologia-plan',
                            'referente': this.referente
                        });
                    }
                });
            },

            dataPlans: function () {
                var PlanData = sessionStorage.getItem("DataQuotation");
                if (PlanData != null) {
                    this.PlanJson = JSON.parse(PlanData);
                    const { plans, modulesPlan } = this.PlanJson[0];
                    this.plansLength = plans.length;
                    this.plans = plans;
                    this.modulesPlan = modulesPlan
                    plans.forEach((plan, i) => {
                        const finallyCalculationResultPlan = plan.finallyCalculationResult.find(o => o.detalleInt == 1);
                        Object.assign(plan, modulesPlan[i], finallyCalculationResultPlan);
                        //se agruparon en un único forEach para aplicar los mismos cambios a cada uno de estos campos.
                        ['premioMensual', 'premiumWithoutDiscount', 'capital'].forEach(field => {
                            plan[field] = parseFloat(plan[field].toString().replace(/\./g, ''));
                            plan[field] = plan[field].toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                        });
                    })
                }
                this.getCoverNote();
            },

            getCoverNote: function () {
                var productId = 1000;
                var securityGroup = '';
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date().toISOString();
                return new Promise<any>(async (resolve) => {
                    coverNoteService.getCoverNote(onDate, productId, securityGroup, correlationInformation, userName, userToken, tokenType)
                        .then(response => {
                            if (response) {
                                this.coberturas = response.filter(o => o.isChecked == true);
                                this.notCover = response.filter(o => o.isChecked == false);
                                sessionStorage.setItem("cover", JSON.stringify(this.coberturas || []));
                                sessionStorage.setItem("notCover", JSON.stringify(this.notCover || []));
                            }
                            else {
                                NF.UI.Page.unblock();
                            }
                        })
                    resolve(true);
                })
            },
            getInitData() {
                this.tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                this.dataGood = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                this.rangeSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                this.descriptionPlanNote = this.dataGood.planNote;
                const additionalInformation = {
                    'Producto': this.dataGood.productDescription,
                    'Suma asegurada': this.rangeSelected.productDescription,
                };
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.tabOneWelcome.email, location.href, this.tabOneWelcome.areaCode, this.tabOneWelcome.telephone, 1000, false, "4", additionalInformation, this.tabOneWelcome.lastName, this.tabOneWelcome.firstName);
                this.dataPlans();
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                    'product': 'tecnologia',
                    'event': 'cotizador-tecnologia-valor',
                    'referente': this.referente
                });
                sessionStorage.removeItem("pressBack");
                var fromTabThree = sessionStorage.getItem("FromTabThree");
                var fromTabFour = sessionStorage.getItem("FromTabFour");
                if (fromTabThree == "true" && fromTabFour == "true") {
                    sessionStorage.setItem("FromTabThree", "false");
                } else {
                    sessionStorage.setItem("FromTabThree", "false");
                    sessionStorage.setItem("FromTabFour", "true");
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                const parallelPromises = [
                    this.getInitData(),
                    this.updateByProductGoogleAnalytics()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.pageCustomization();


            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
